import { useUserSWR } from "../lib/api/user-swr";
import { User } from "../lib/api/user";

export function useUser() {
  const { data, mutate, error } = useUserSWR();
  const loading = !data && !error;
  const loggedOut =
    (error && error.status === 401) 
    || (data && data.user === null);
  const user: User | null = error ? null : data ? data.user : null;
  return {
    loading,
    loggedOut,
    error,
    user,
    mutate,
  };
}
